module.exports = __webpack_public_path__ + "img/chengmenlou.a13fd476.png";